/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.d.ts
 * Class: index.d.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import CheckoutContractDurationList from './CheckoutContractDurationList.vue';
import CheckoutLocationList from './CheckoutLocationList.vue';
import CheckoutPrice from './CheckoutPrice.vue';
import CheckoutUnit from './CheckoutUnit.vue';

export {
  CheckoutContractDurationList, CheckoutLocationList, CheckoutPrice, CheckoutUnit,
};
